import { createIntl, createIntlCache, defineMessages } from "react-intl";
import { z } from "zod";
import messagesEn from "../../../translations/en.json";
import messagesEs from "../../../translations/es.json";

const locale = window.localStorage.getItem("locale") || navigator.language;
const messages: Record<string, Record<string, string>> = {
  "en-US": messagesEn,
  "es-ES": messagesEs,
};

const cache = createIntlCache();
let intl = createIntl({ locale, messages: messages[locale] }, cache);

const validationMessages = defineMessages({
  numberTooSmall: {
    id: "app.input.numberTooSmall",
    defaultMessage: "Number must be greater than or equal to {value}",
  },
  stringTooSmall: {
    id: "app.input.stringTooSmall",
    defaultMessage: "String must be at least {value} characters",
  },
});

// TODO - add all zod validation translations here
const customErrorMap: z.core.$ZodErrorMap = issue => {
  if (issue.code === "too_small") {
    return intl.formatMessage(validationMessages.numberTooSmall, {
      value: issue.minimum.toString(),
    });
  }

  // custom code with message ids
  if (issue.code === "custom" && issue.params?.messageId) {
    return { message: intl.formatMessage({ id: issue.params.messageId }) };
  }
};

z.config({ customError: customErrorMap });

export const setZodLocale = (locale: string) => {
  intl = createIntl({ locale, messages: messages[locale] }, cache);
};
